(function () {
  function initNereoBuyNow() {
    if (typeof subscribe !== 'function') return;

    var eventName =
      (typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) || 'cart-update';

    subscribe(eventName, function (event) {
      // Solo redirigimos a checkout cuando el "add to cart" vino del formulario
      // de compra de la página de producto (no de cambios de cantidad en el
      // carrito ni de otras fuentes), para no alterar el comportamiento normal
      // del carrito en el resto del sitio.
      if (
        event &&
        event.source === 'product-form' &&
        window.location.pathname.indexOf('/products/') === 0
      ) {
        window.location.href = '/checkout';
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initNereoBuyNow);
  } else {
    initNereoBuyNow();
  }
})();
